// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__MJjju","name":"Header_name__2Rq5D","birthday":"Header_birthday__2Rbsm","skeleton":"Header_skeleton__2_eOL"};